import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import i18n from './i18n/index.js'
import {checkSystemn} from './utils/common'
Vue.config.productionTip = false
import VueRouter from "vue-router";
import 'element-ui/lib/theme-chalk/index.css';
import { Button, Select, Input, Form, FormItem, Upload, Checkbox, Option, Message } from 'element-ui';
Vue.use(Button).use(Select).use(Input).use(Form).use(FormItem).use(Upload).use(Checkbox).use(Option);
Vue.prototype.$message = Message;
const isMobile = checkSystemn() != 'pc'
console.log(isMobile);
let routes = [
  {
    path: "/",
    redirect: { name: "submitToView" },
  },
  {
    path: "/vulnerability-from",
    name: "submitToView",
    component: isMobile ? () => import("./views/mobile/submitToView.vue") : () => import("./views/submitToView.vue"),
  },
  {
    path: "/vulnerability-show",
    name: "disclosure",
    component: isMobile ? () => import("./views/mobile/disclosure.vue") : () => import("./views/disclosure.vue"),
  }, 
  {
    path: "/vulnerabilitypolicy-show",
    name: "verabilityDisclosurePolicy",
    component: isMobile ? () => import("./views/mobile/verabilityDisclosurePolicy.vue") : () => import("./views/verabilityDisclosurePolicy.vue"),
  },
  {
    path: "/privacypolicy",
    name: "privacyPolicy",
    component: isMobile ? () => import("./views/mobile/privacyPolicy.vue") : () => import("./views/privacyPolicy.vue"),
  },
  {
    path: "/productsupportcycle",
    name: "productsupportcycle",
    component: isMobile ? () => import("./views/mobile/productsupportcycle.vue") : () => import("./views/productsupportcycle.vue"),
  },
];

// Create the router instance with the defined routes
const dynamicRouter = new VueRouter({
  routes,
});
new Vue({
  router:dynamicRouter,
  store,
  render: (h) => h(App),
  i18n,
}).$mount("#app");

